var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FFD15C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.476 36.3451L63.5382 15.864C63.3378 15.5921 63.0914 15.3745 62.8155 15.2255C62.5395 15.0765 62.2403 14.9997 61.9378 15H32.0622C31.7597 14.9997 31.4605 15.0765 31.1845 15.2255C30.9086 15.3745 30.6622 15.5921 30.4618 15.864L15.524 36.3451C15.177 36.8281 14.9905 37.4477 15.0004 38.0854C15.0102 38.723 15.2156 39.3339 15.5774 39.8012L45.4529 78.2032C45.6522 78.4549 45.8922 78.6554 46.1582 78.7924C46.4241 78.9294 46.7106 79 47 79C47.2894 79 47.5759 78.9294 47.8418 78.7924C48.1078 78.6554 48.3478 78.4549 48.5471 78.2032L78.4226 39.8012C78.7844 39.3339 78.9898 38.723 78.9996 38.0854C79.0095 37.4477 78.823 36.8281 78.476 36.3451V36.3451ZM72.1808 35.481H61.1375L51.3213 20.1203H60.9775L72.1808 35.481ZM32.4624 40.6013L40.6248 64.4745L22.0326 40.6013H32.4624ZM56.9229 40.6013L47 69.6907L37.0771 40.6013H56.9229ZM38.2241 35.481L47 21.7523L55.7759 35.481H38.2241ZM61.5376 40.6013H71.9674L53.3752 64.4745L61.5376 40.6013ZM33.0225 20.1203H42.6787L32.8625 35.481H21.8192L33.0225 20.1203Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/d3.e5a28483a441afe5b7a69d8fb2009a47.svg";
export { ForwardRef as ReactComponent };